
define('text!plugins/textarea/setupTemplate.html',[],function () { return '';});

